import React, { useContext, useEffect, useState } from 'react';
import LinearGradient from 'react-native-linear-gradient';
import { PlayerUIContext, closeModal, modalType } from '@24i/player-ui';
import { usePrevious } from '@24i/player-utils-react';
import { useCurrentWebScreenSize } from '@24i/nxg-sdk-smartott/src/hooks/useCurrentWebScreenSize';
import { ModalContainer, Backdrop } from './styled';
import { SettingsModal } from './modals/SettingsModal';
import { EpisodesModal } from './modals/EpisodesModal';
import { ChannelsModal } from './modals/ChannelsModal';
import { RelatedModal } from './modals/RelatedModal';
export const mappedModal = {
    [modalType.settings]: SettingsModal,
    [modalType.episodes]: EpisodesModal,
    [modalType.channels]: ChannelsModal,
    [modalType.related]: RelatedModal,
};
export const Modal = ({ type, playerInstance, className = '', styles = {
    backdrop: null,
    container: null,
    [modalType.settings]: {},
}, seriesData, epgData, relatedItems, shouldBePausedWhenOpen, disableVideoQualitySelector, }) => {
    const [shouldResumeOnClose, setShouldResumeOnClose] = useState(false);
    const { state, dispatch } = useContext(PlayerUIContext);
    const isDisplayed = state[type].isOpen;
    const wasDisplayed = usePrevious(isDisplayed);
    const SelectedModal = mappedModal[type];
    const selectedModalStyles = styles[type];
    const { screenSize } = useCurrentWebScreenSize();
    useEffect(() => {
        if (!playerInstance)
            return;
        if (!shouldBePausedWhenOpen)
            return;
        if (!isDisplayed && wasDisplayed && shouldResumeOnClose)
            playerInstance.play();
        if (isDisplayed && !wasDisplayed && !playerInstance.live) {
            setShouldResumeOnClose(playerInstance.playing);
            playerInstance.pause();
        }
    }, [isDisplayed]);
    return (isDisplayed && (React.createElement(Backdrop, { style: styles.backdrop, "data-test": "Modal-Backdrop", className: "Modal-Backdrop", onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();
            dispatch(closeModal(type));
        } },
        React.createElement(LinearGradient, { key: "gradient", colors: ['rgba(0, 0, 0, 0)', 'rgba(0, 0, 0, 0.7)'], style: {
                width: '100%',
                height: ['XS', 'X'].includes(screenSize) ? '100%' : '50%',
                position: 'absolute',
                bottom: 0,
                left: 0,
            } }),
        React.createElement(ModalContainer, { style: styles.container, "data-test": "Modal", className: `Modal ${className}`, onClick: (event) => {
                event.preventDefault();
                event.stopPropagation();
            } },
            React.createElement(SelectedModal, { styles: selectedModalStyles, "data-test": "Modal-SelectedModal", playerInstance,
                seriesData,
                epgData,
                relatedItems,
                disableVideoQualitySelector })))));
};
export * from './components/ModalTriggeringButton';
//# sourceMappingURL=index.js.map